import DemoAirmate from './demoComponentAirMate.vue'

export default {
  DemoAirmate
}



// WEBPACK FOOTER //
// ./src/components/PdfForm/index.js